/**
 * Get the key for a given date.
 *
 * @param date The date to get the key for.
 * @returns The key for the given date.
 */
export function getDateKey(date: Date | string) {
  let dateTimeString = '';

  if (typeof date === 'string') {
    dateTimeString = date;
  } else {
    dateTimeString = date.toISOString();
  }

  return dateTimeString;
}
